import * as React from "react";
import Box from "@mui/material/Box";
import Drawer from "@mui/material/Drawer";
import Button from "@mui/material/Button";
import List from "@mui/material/List";
import Divider from "@mui/material/Divider";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import { Link } from "react-router-dom";
import Cookies from "js-cookie";
import DashboardIcon from "@mui/icons-material/Menu";
import Menu from "./Minu";
import dashboard from "../Images/dashboard.png";
import order from "../Images/order.png";
import product from "../Images/add-product.png";
import profile from "../Images/profile.png";
import logOut from "../Images/logout.png";
import debt from "../Images/borrow.png";
import Logo from "../Images/favicon.jpg";
import Facebook from "../Images/facebook.png";
import WhatSApp from "../Images/whatsapp.png";

// import WhatSApp from "../image/whatisup.jpg";
import "../Styles/NavBar.css";
import axios from "axios";
const NavBar = () => {
  const [state, setState] = React.useState({
    left: false,
  });
  //todo this is Order =======================
  const [receivedCount, setReceivedCount] = React.useState(0);

  React.useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `https://bardawamplus.com/api/orders/store/${Cookies.get("store")}`
        );
        const count = response.data.data.filter(
          (item) => item.status === 1
        ).length;
        setReceivedCount(count);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
    fetchData();
  }, []);
  //! ======================================================
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
  };

  const list = (anchor) => (
    <Box
      sx={{
        width: anchor === "top" || anchor === "bottom" ? "auto" : 350,
      }}
      role="presentation"
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <List sx={{ backgroundColor: "#white", padding: "20px" }}>
        <img src={Logo} alt="logo" className="Logoo" />
        <ListItem button key="Dashboard" disablePadding>
          <Link
            to="/"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={dashboard}
              alt="Dashboard"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="dashboard" />
          </Link>
        </ListItem>
        <ListItem button key="Products" disablePadding>
          <Link
            to="/Products"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={product}
              alt="Products"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="Products" />
          </Link>
        </ListItem>

        <ListItem button key="OrderTable" disablePadding>
          <Link
            to="/OrderTable"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={order}
              alt="OrderTable"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText
              primary={
                <>
                  Order Table
                  <span
                    style={{
                      backgroundColor: "#f50057", // Your background color
                      color: "white", // Text color
                      borderRadius: "12px",
                      padding: "2px 8px",
                      marginLeft: "10px",
                      fontSize: "0.875rem",
                    }}
                  >
                    {receivedCount}
                  </span>
                </>
              }
            />
          </Link>
        </ListItem>
        <ListItem button key="Debt" disablePadding>
          <Link
            to="/Debt"
            style={{
              textDecoration: "none",
              color: "inherit",
              display: "flex",
              alignItems: "center",
            }}
          >
            <img
              src={debt}
              alt="Debt"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <ListItemText primary="Debt" />
          </Link>
        </ListItem>
        {[].map(({ icon, text }) => (
          <ListItem button key={text} disablePadding>
            {icon && <img src={icon} alt="icon" width={24} height={24} />}
          </ListItem>
        ))}
      </List>
      <Divider />
      <List sx={{ backgroundColor: "#white", padding: "30px" }}>
        {[
          {
            icon: (
              <img
                src={profile}
                alt="icon"
                width={24}
                height={24}
                style={{ marginRight: "10px" }}
              />
            ),
            text: "profile",
            link: "/Profile",
          },
          {
            icon: (
              <img
                src={logOut}
                alt="icon"
                width={24}
                height={24}
                style={{ marginRight: "10px" }}
              />
            ),
            text: "logout",

            onClick: () => {
              Cookies.remove("user");
              Cookies.remove("store");
              window.location.href = "/";
            },
          },
        ].map(({ icon, text, link, onClick }) => (
          <ListItem button key={text} disablePadding onClick={onClick}>
            {icon}
            <span style={{ marginLeft: "10px" }}>
              {link ? (
                <Link
                  to={link}
                  style={{ textDecoration: "none", color: "inherit" }}
                >
                  <ListItemText primary={text} />
                </Link>
              ) : (
                text
              )}
            </span>
          </ListItem>
        ))}
        <br />
        {/* <DarkMode /> */}
        <ul className="navbar-info">
          <li>Make by</li>
          <li>
            <img
              src={Facebook}
              alt="Facebook"
              width={24}
              height={24}
              style={{ marginRight: "10px" }}
            />
            <a
              href="https://www.facebook.com/TechTopia1998"
              target="_blank"
              rel="noopener noreferrer"
            >
              TechTopia
            </a>
          </li>
          <li>
            <img
              src={WhatSApp}
              alt="WhatsApp"
              width={24}
              height={24}
              style={{ marginRight: "2px" }}
            />
            <a
              href="https://wa.link/1o8y3b"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span> </span>
              07811421542
            </a>
          </li>
        </ul>
      </List>
    </Box>
  );
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div>
        {["left"].map((anchor) => (
          <React.Fragment key={anchor}>
            <Button
              variant="contained"
              color="success"
              onClick={toggleDrawer(anchor, true)}
              style={{ marginRight: "50px", borderRadius: 8 }}
              startIcon={<DashboardIcon />}
            >
              {anchor}
            </Button>
            <Drawer
              anchor={anchor}
              open={state[anchor]}
              onClose={toggleDrawer(anchor, false)}
              sx={{ "& .MuiDrawer-paper": { width: "250px" } }}
            >
              {list(anchor)}
            </Drawer>
          </React.Fragment>
        ))}
      </div>
      <Menu />
    </div>
  );
};

export default NavBar;
